/* @flow */

import React from 'react'
import { connect } from 'react-redux'

import { Tabs } from 'react-tabs'
import MainNavigation from './MainNavigation'
import Alert from './Alert'
import LoginLaunchAlert from './LaunchAlert/LoginLaunchAlert'
import LaunchAlert from './LaunchAlert/LaunchAlert'
import ErrorModal from './ErrorModal'
import CopyPollModal from './PollCopy/PollCopy'

import type { RootState } from '../types'
import { selectCurrentUser } from '../stores/currentUser'
import { selectIsCurrentUserFetched } from '../stores/isCurrentUserFetched'
import { fetchCurrentUserInitially } from '../sagas/fetchCurrentUser'
import { logoutButtonClick } from '../sagas/logout'
import { isToolPollCreatorUser, isToolUser } from '../stores/usersStore'
import {
  LIBRARY_URL,
  LOGIN_URL,
  REDIRECT_QUERY_PARAM_KEY,
  TOOL_URL,
} from '../urls'

type Props = {
  isCurrentUserFetched: boolean,
  location: Object,
  logoutButtonClick: () => void,
  fetchCurrentUserInitially: () => void,

  // flow can't typecheck children yet
  children?: any,
  user: Object,
  toolEnabled: boolean,
  toolPollCreatorEnabled: boolean,
}

type StateProps = {
  isCurrentUserFetched: boolean,
  location: Object,
}

Tabs.setUseDefaultStyles(false)

class App extends React.Component<Props, StateProps> {
  props: Props

  componentDidMount() {
    const { fetchCurrentUserInitially } = this.props
    fetchCurrentUserInitially()
  }

  render() {
    if (!this.props.isCurrentUserFetched) {
      return null
    }

    const { location } = this.props

    const isRedirectFromTool =
      location.query[REDIRECT_QUERY_PARAM_KEY] === 'tool'
    const path = location.pathname
    const isLoginPage = path === '/login'

    console.log({ isRedirectFromTool, path, isLoginPage })

    if (isLoginPage && !isRedirectFromTool) {
      window.location.href = LOGIN_URL
    }

    console.log(this.props.toolEnabled, this.props.toolPollCreatorEnabled)

    if (this.props.toolEnabled && this.props.toolPollCreatorEnabled) {
      const createPollRegex = new RegExp(/\/new-poll\/([\w-]*)/)

      const isCreatePollPage = path.match(createPollRegex)

      if (isCreatePollPage && Array.isArray(isCreatePollPage)) {
        const pollType = isCreatePollPage[1]
        window.location.href = `${TOOL_URL}/library/poll/create/${pollType}`
      }

      const isEditPollPage = path.match(new RegExp(/\/polls\/([\S]*)/))

      if (isEditPollPage && Array.isArray(isEditPollPage)) {
        const pollId = isEditPollPage[1]
        window.location.href = `${TOOL_URL}/library/poll/edit/${pollId}`
      }
    }

    const isPollEditOrCreatePage =
      path.match(new RegExp(/\/new-poll\//)) ||
      path.match(new RegExp(/\/polls\//))

    console.log({ isPollEditOrCreatePage })

    if (
      !isRedirectFromTool &&
      !isPollEditOrCreatePage &&
      this.props.toolEnabled
    ) {
      console.log('redirecting to library')
      window.location.href = LIBRARY_URL
    }

    return (
      <div
        id="react-app-root"
        className={`h-100 w-100 ${
          isLoginPage ? 'bg-white' : 'bg-op-con-light'
        }`}
      >
        <ErrorModal />
        <CopyPollModal />
        <MainNavigation
          logoutButtonClick={this.props.logoutButtonClick}
          isLoginPage={isLoginPage}
        />
        {isLoginPage && <LoginLaunchAlert />}
        {!isLoginPage && <LaunchAlert />}
        <Alert />

        <div
          className={`flex justify-center align-center pa5 ${
            isLoginPage ? 'bg-white' : 'bg-op-con-light'
          }`}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state: RootState, ownProps: Object): StateProps {
  const user = selectCurrentUser(state)
  return {
    isCurrentUserFetched: selectIsCurrentUserFetched(state),
    location: ownProps.location,
    user,
    toolEnabled: isToolUser(user),
    toolPollCreatorEnabled: isToolPollCreatorUser(user),
  }
}

const mapDispatchToProps = {
  logoutButtonClick: logoutButtonClick,
  fetchCurrentUserInitially: fetchCurrentUserInitially,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/components/App.js